'use strict';
var _ = require('underscore');
var util = require('../helper/util');
var propConst = require('../constants/propConst');
/*
 <states>
 <state propName="Color" stateType="state_mouseOver" isChecked="True" value="4293875286" varType="20"/>
 </states>
 */

var STATE_TYPE = {
  MOUSE_DOWN: 'state_mouseDown',
  MOUSE_UP: 'state_mouseUp',
  MOUSE_OVER: 'state_mouseOver',
  MOUSE_OUT: 'state_mouseOut'
};

var parse = {
  parseToColor: function (value) {
    return util.Color.toHTMLColor(value);
  },

  parseToBool: function (value) {
    return value === true || value === 'True';
  },

  parseToInt: function (value) {
    return util.Int(value)
  },

  parseToFloat: function (value) {
    return util.Float(value);
  },

  parseToText: function (value) {
    return util.Text.decode(value);
  },

  parseValue: function (v, t) {
    t = this.parseToInt(t);
    switch (t) {
      case 11:
        return this.parseToBool(v);
      case 19:
      case 20:
      case 21:
        return this.parseToColor(v);
      case 4:
      case 5:
      case 6:
        return this.parseToFloat(v);
      case 2:
      case 3:
      case 16:
      case 17:
      case 18:
        return this.parseToInt(v);
      case 256:
      case 258:
        return this.parseToText(v);
      default:
        return v;
    }
  },

  parseName: function (v) {
    switch (v) {
      case 'IsShow':
      case 'Color':
      case 'BorderColor':
      case 'BorderVisible':
      case 'DashMode':
      case 'Thickness':
      case 'Radius':
      case 'Text':
      case 'TextSize':
      case 'TextColor':
      case 'InterlaceColor':
      case 'IsOpen':
      case 'FilterType':
      case 'FilterSketchValue':
      case 'FilterPencilValue':
      case 'Progress':
      case 'BarStyle':
      case 'RotationAngle':
      case 'IconColor':
      case 'IndicatorColor':
      case 'Size':
      case 'Status':
      case 'ShowIcon':
      case 'MultilineText':
        return v.charAt(0).toLowerCase() + v.substring(1);
      case 'FlipVertical':
      case 'FlipHorizontal':
      case 'ForegroundColor':
        return v;
      case 'GAP':
        return propConst.GAP;
      case 'Alpha100':
        return propConst.OPACITY;
      case 'VScrollProgress':
        return 'verticalScrollbarProgress';
      case 'HScrollProgress':
        return 'horizontalScrollbarProgress';
      case 'CheckBoxStatus':
        return 'state';
      case 'IsFullScreen':
        return 'fullScreen';
      case 'Transparent':
        return 'isTransparent';
      case 'PhoneStatus':
        return 'phoneType';
    }
    return v;
  }
};

var state = {
  createNew: function (reactComp) {
    return {
      isStateChange: false,
      currentState: undefined,
      doTriggerState: function () {
        var state = this.findState(this.currentState);
        if (state) {
          this.isStateChange = true;
          this.comp.setState({stateProperties: state});
        }
      },

      doFreeState: function () {
        if (this.isStateChange) {
          this.comp.setState({stateProperties: undefined});
        }
        this.isStateChange = false;
      },

      down: function () {
        this.currentState = STATE_TYPE.MOUSE_DOWN;
        this.doTriggerState();
      },
      up: function () {
        this.doFreeState();
      },

      hover: function () {
      },

      enter: function () {
        this.currentState = STATE_TYPE.MOUSE_OVER;
        this.doTriggerState();
      },

      leave: function () {
        this.doFreeState();
      },
      comp: reactComp,

      findState: function (stateType) {
        var o;
        var i;
        var state = this.comp.props.states;
        var item;
        if (!_.isEmpty(state)) {
          state = state.state;
          if (!_.isUndefined(state)) {
            for (i = 0; i < state.length; i++) {
              item = state[i];
              if (item.stateType === stateType) {
                if (item.isChecked) {
                  if (!o) {
                    o = {};
                  }
                  o[parse.parseName(item.propName)] = parse.parseValue(item.value, item.varType);
                }
              }
            }
          }
        }
        return o;
      }
    };
  }
};

/**
 *
 * @param reactComp
 */
module.exports = function (reactComp) {
  var _state = state.createNew(reactComp);
  this.state = function () {
    return _state;
  };
};

module.exports.prototype.mouseDown = function (e) {
  if (e.button === 0) {
    this.state().down();
  }
};

module.exports.prototype.mouseUp = function (e) {
  this.state().up();
};
module.exports.prototype.mouseEnter = function (e) {
  this.state().enter();
};
module.exports.prototype.mouseLeave = function (e) {
  this.state().leave();
};




// WEBPACK FOOTER //
// ./src/interactive/stateInteractive.js